class FormSelect extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
       const $select = <HTMLElement>this.querySelector(".select");
       $select.addEventListener("click", this.selectClickEventHandler.bind(this));

       const $options = this.querySelectorAll(".form-select__options .option");
        $options.forEach(($option) => {
            $option.addEventListener("click", this.optionSelectEventHandler.bind(this))
        })
    }

    selectClickEventHandler(event: Event) {
        const target = event.currentTarget as HTMLElement;
        target.classList.add("active");
    }


    optionSelectEventHandler(event: Event) {
        event.stopImmediatePropagation();
        const target = event.currentTarget as HTMLElement;
        const value = target.innerHTML as string;
        const valueOption = this.querySelector(".option-value div") as HTMLElement;
        valueOption.innerText = value;

        this.querySelector(".select")?.classList.remove("active");

    }
}

customElements.define('form-select', FormSelect);